<template>
  <div id="app">
    <!-- Fixed navbar -->
    <navbar />

    <!-- Begin page content -->
    <router-view style="min-height: calc(100vh - 240px)"></router-view>

    <myfooter />
  </div>
</template>

<script>
import navbar from '@/components/Navbar.vue'
import myfooter from '@/components/Footer.vue'
export default {
  name: 'App',

  components: {
    navbar,
    myfooter
  }
}
</script>

<style lang="scss">
#app {
}
</style>
